//文字コードはutf-8

/**
 * tablet時（769-1160px）にpageWrapperをスケールする処理
 * 1160pxを基準に、画面幅に応じて比率を変更
 */
const TABLET_SCALE_BASE = 1160; // SCSSの$bp_tablet_maxと同じ値

const isTabletMediaQuery = window.matchMedia('(min-width: 769px) and (max-width: 1160px)');

// bodyの高さを調整する関数
function updateBodyHeight() {
  // タブレットでない場合は実行しない
  if (!isTabletMediaQuery.matches) return;
  
  const pageWrapper = document.querySelector('.pageWrapper');
  if (!pageWrapper) return;
  
  // タブレットの基本スケールを取得
  // 検索バーのズームはbodyに適用されるため、ここでは考慮しない
  const ratio = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scale-ratio')) || 1;
  if (ratio <= 0 || ratio > 1) return; // 無効な比率の場合は実行しない
  
  // レイアウトが安定するまで少し待つ（複数回試行）
  const adjustHeight = (attempts = 0) => {
    requestAnimationFrame(() => {
      // 再度タブレットかどうかチェック（実行中に変更された可能性がある）
      if (!isTabletMediaQuery.matches) {
        document.body.style.height = '';
        return;
      }
      
      // pageWrapperの実際のDOM上の高さを取得
      const pageWrapperHeight = pageWrapper.offsetHeight;
      
      // 高さが0の場合は再試行（最大5回）
      if (pageWrapperHeight === 0 && attempts < 5) {
        setTimeout(() => adjustHeight(attempts + 1), 50);
        return;
      }
      
      // スケール後の見た目の高さを計算
      const scaledPageWrapperHeight = pageWrapperHeight * ratio;
      
      // bodyの高さをスケール後の見た目の高さに合わせて設定
      // headerはposition: fixedなのでbodyの高さには影響しない
      document.body.style.height = `${scaledPageWrapperHeight}px`;
    });
  };
  
  adjustHeight();
}

export function updateTabletScale() {
  const isTablet = isTabletMediaQuery.matches;
  
  // 検索バーがズーム中かどうかを確認（headerSearch.jsで設定されるis-zoomedクラス）
  const searchForm = document.querySelector('.jsHeaderSearch');
  const isSearchZoomed = searchForm && searchForm.classList.contains('is-zoomed');
  
  // タブレット以外では、まず確実にリセット処理を実行
  if (!isTablet) {
    // bodyにis-tabletクラスを削除
    document.body.classList.remove('is-tablet');
    // スタイルをリセット
    document.body.style.height = '';
    // CSS変数を削除
    document.documentElement.style.removeProperty('--scale-ratio');
    return;
  }
  
  // タブレット時、検索バーがズーム中の場合はスキップ（検索バーのズーム処理に任せる）
  if (isSearchZoomed) {
    // ただし、bodyの高さの調整は実行する（検索バーのズーム中でも必要）
    updateBodyHeight();
    return;
  }
  
  // タブレット時
  // bodyにis-tabletクラスを追加
  document.body.classList.add('is-tablet');
  
  // 1160px に対する現在の画面幅の比率を計算
  const ratio = window.innerWidth / TABLET_SCALE_BASE;
  // CSS変数 '--scale-ratio' に値をセット（:rootに設定）
  document.documentElement.style.setProperty('--scale-ratio', ratio.toString());
  
  // bodyの高さをスケール後の見た目に合わせて調整
  // pageWrapperが存在する場合は即座に実行、存在しない場合は少し待ってから実行
  const pageWrapper = document.querySelector('.pageWrapper');
  if (pageWrapper) {
    updateBodyHeight();
  } else {
    // pageWrapperがまだ作成されていない場合、少し待ってから再試行
    setTimeout(() => {
      if (document.querySelector('.pageWrapper')) {
        updateBodyHeight();
      }
    }, 100);
  }
}

// updateBodyHeightをエクスポート（headerScrolling.jsから呼び出し可能にする）
export { updateBodyHeight };

// 読み込み時とリサイズ時に実行
export function initTabletScale() {
  let resizeTimer = null;
  
  // メディアクエリの変化を監視
  if (isTabletMediaQuery.addEventListener) {
    isTabletMediaQuery.addEventListener('change', updateTabletScale);
  }
  
  // リサイズイベントをdebounce（連続実行を防ぐ）
  window.addEventListener('resize', () => {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(() => {
      updateTabletScale();
      resizeTimer = null;
    }, 100);
  });
  
  updateTabletScale(); // 即時実行
}

